export enum AllocationStatus {
  Active = 0,
  Pending = 1,
  Waitlisted = 2,
  Terminated = 3,
  Cancelling = 4
}

export const AllocationStatusValues = [
  {
    name: 'Active',
    id: AllocationStatus.Active,
    abbr: 'A'
  },
  {
    name: 'Pending',
    id: AllocationStatus.Pending,
    abbr: 'P'
  },
  {
    name: 'Waitlisted',
    id: AllocationStatus.Waitlisted,
    abbr: 'W'
  },
  {
    name: 'Terminated',
    id: AllocationStatus.Terminated,
    abbr: 'T'
  },
  {
    name: 'Cancelling',
    id: AllocationStatus.Cancelling,
    abbr: 'C'
  }
];
